import type {WorkstreamAuditResponse} from 'client';
import type {GroupTab} from 'components/DSYS/GroupTabs';
import {GroupTabs} from 'components/DSYS/GroupTabs';
import {t} from 'i18next';

export const WORKSTREAM_AUDIT_EXEC_SPONSOR_TAB = 'exec_sponsor';
export const WORKSTREAM_AUDIT_DRI_TAB = 'dri';
export const WORKSTREAM_AUDIT_REPORTER_TAB = 'reporter';
export const WORKSTREAM_AUDIT_STEAM_OWNER_TAB = 'steam_owner';
export const WORKSTREAM_AUDIT_COMPANY_TAB = 'company';

export type WorkstreamAuditTab =
  | typeof WORKSTREAM_AUDIT_EXEC_SPONSOR_TAB
  | typeof WORKSTREAM_AUDIT_DRI_TAB
  | typeof WORKSTREAM_AUDIT_REPORTER_TAB
  | typeof WORKSTREAM_AUDIT_STEAM_OWNER_TAB
  | typeof WORKSTREAM_AUDIT_COMPANY_TAB;

export const WorkstreamAuditTabs = ({
  activeTab,
  audit,
  onTabChange,
}: {
  activeTab: WorkstreamAuditTab;
  audit: Pick<
    WorkstreamAuditResponse,
    'exec_sponsor' | 'dri' | 'reporter' | 'steam_owner' | 'company'
  >;
  onTabChange: (tab: WorkstreamAuditTab) => void;
}) => {
  const tabs: GroupTab[] = [
    {
      id: WORKSTREAM_AUDIT_EXEC_SPONSOR_TAB,
      label: t('workstream_audit_exec_sponsor_tab').toString(),
      count: audit.exec_sponsor.count,
      disabled: false,
    },
    {
      id: WORKSTREAM_AUDIT_DRI_TAB,
      label: t('dri').toString(),
      count: audit.dri.count,
      disabled: false,
    },
    {
      id: WORKSTREAM_AUDIT_REPORTER_TAB,
      label: t('workstream_role_label_reporter').toString(),
      count: audit.reporter.count,
      disabled: false,
    },
    {
      id: WORKSTREAM_AUDIT_STEAM_OWNER_TAB,
      label: t('workstream_role_label_steam_owner').toString(),
      count: audit.steam_owner.count,
      disabled: false,
    },
    {
      id: WORKSTREAM_AUDIT_COMPANY_TAB,
      label: t('workstream_audit_company_tab').toString(),
      count: audit.company.count,
      disabled: false,
    },
  ].filter((tab) => tab.id === WORKSTREAM_AUDIT_COMPANY_TAB || tab.count > 0);

  return (
    <nav aria-label={t('workstream_audit_views')}>
      <GroupTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={(tabId) => {
          if (
            tabId === WORKSTREAM_AUDIT_EXEC_SPONSOR_TAB ||
            tabId === WORKSTREAM_AUDIT_DRI_TAB ||
            tabId === WORKSTREAM_AUDIT_REPORTER_TAB ||
            tabId === WORKSTREAM_AUDIT_STEAM_OWNER_TAB ||
            tabId === WORKSTREAM_AUDIT_COMPANY_TAB
          ) {
            onTabChange(tabId);
          }
        }}
        totalCount={audit.company.count}
        showAllTab={false}
        pressedState
      />
    </nav>
  );
};
